import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import paths from 'commons/paths';
import { useMyPage } from 'hooks';
import { MyBoardTable } from 'components/pages/MyPage/Community/Board';

const BOARD_COUNT_TO_SHOW = 5;

const BoardSection = () => {
  const { boards, boardsIsValidating, setPage } = useMyPage({});

  useEffect(() => {
    setPage('1');
  }, []);

  if (boardsIsValidating) return <></>;

  return (
    <div className="mypage_section">
      <div className="mypage_inner">
        <div className="mypage_top">
          <h3 className="mypage_top_title">작성한 게시글 - 자유게시판</h3>
          {(boards?.totalAmount as number) > BOARD_COUNT_TO_SHOW ? (
            <Link to={`${paths.getPath('myboard')}`} className="mypage_top_link">
              모두 보기
            </Link>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="mypage_board list_table">
        <MyBoardTable
          list={boards?.mainBoardList || []}
          count={boards?.totalAmount as number}
          limit={BOARD_COUNT_TO_SHOW}
          ga_belong="마이페이지/작성한 게시글 - 자유게시판"
        />
      </div>
    </div>
  );
};

export default BoardSection;
